import React, { LegacyRef, useState } from "react";
import { Bar, Line } from "react-chartjs-2";

const GraphContext = React.createContext<any>(null);

type Props = {
  children: JSX.Element;
  timeTitle: string | undefined;
  label: string | undefined;
};

export function GraphProvider({ children, timeTitle, label }: Props) {
  const [ref, setRef] = useState<LegacyRef<Bar | Line | undefined>>(
    React.useRef<Bar | Line | null>(null)
  );

  return (
    <GraphContext.Provider value={{ ref, setRef, timeTitle, label }}>
      {children}
    </GraphContext.Provider>
  );
}

export const useGrapContext = () => React.useContext(GraphContext);
